import { FC } from "react";
import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

const DashboardModalContentStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "dashboard-modal-content",
})`
  width: 200px;
`;

export const DashboardModalContent: FC = () => {
  return (
    <DashboardModalContentStyled>
      Modal content home inner{" "}
      {/* //TODO: add translation solution/key ? if needed */}
    </DashboardModalContentStyled>
  );
};
